import { actionCompleted } from "@ignitesales/neuro-application/src/actions/question-action-creators";
import AnswersList from "@ignitesales/neuro-application/src/components/AnswersList";
import buildPageUrl from "@ignitesales/neuro-application/src/page/buildPageUrl";
import { flatProductList } from "@ignitesales/neuro-application/src/util/productUtil.mjs";
import classnames from "classnames";
import React, { useContext } from "react";
import { FormattedHTMLMessage, FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import GuideContext from '../../GuideContext';
import MessageWithRuleEvaluation from "../MessageWithRuleEvaluation";
import Product from "../Product";

const DetailsPage = ({ classname, answers, products, detailsUrl, summaryUrl }) => {
  const pageCssBEM = "detailsPage";
  const classes = classnames(pageCssBEM, classname);
  const {isBusinessGuide} = useContext(GuideContext);
  const productList = (products.groups || [])
    .map((g) => {
      return flatProductList(g);
    })
    .flat();

  //@TODO Remove? or move logic to answersList for Neuro for basic timestamp sort? Not currently using in the refactor
  const userAnswers = Object.values(answers).sort((a, b) => {
    return a.timestamp - b.timestamp;
  });
  const size = 2;
  const chunkedAnswers = [];
  let index = 0;
  while (index < userAnswers.length) {
    chunkedAnswers.push(userAnswers.slice(index, size + index));
    index += size;
  }
  // END TODO

  const renderOtherAccounts = () => {
    const accountTypes = [
      "feeAdvisory",
      "cashManagement",
      "personalLoans",
      "homeLoanLine",
      "financialPlanning",
      "trustServices",
      "mortgage",
      "retirement",
      "investmentAdvisoryServices",
    ];
    let otherAccounts = [];
    accountTypes.map((id) => {
      let message = (
        <MessageWithRuleEvaluation id={id} key={id}>
          <FormattedHTMLMessage id={id} tagName="li" />
        </MessageWithRuleEvaluation>
      );
      message ? otherAccounts.push(message) : null;
    });
    return otherAccounts;
  };

  const onPrintClick = () => {
    actionCompleted("printFormClicked");
    if (detailsUrl) {
      window.print(detailsUrl);
    }
  };

  const onBackToSummaryClick = () => {
    actionCompleted("backToSummaryClicked");
    if (summaryUrl) {
      window.location.href = summaryUrl;
    }
  };

  return (
    <div className={classes}>
      <div className={`${pageCssBEM}__blueCorner`} />
      <div className={`${pageCssBEM}__container`}>
        <div className={`${pageCssBEM}__headerBar`}>
          <div className={`${pageCssBEM}__headerActions p-2 pt-4`}>
            <div className={`${pageCssBEM}__headerTitle py-2`}>
              <FormattedMessage id={pageCssBEM} tagName="h1" />
            </div>
            <div className={`${pageCssBEM}__headerSocial py-2`}>
              <button className={`btn btn--small ${isBusinessGuide ? 'btn--outline' : ''}`} onClick={onBackToSummaryClick}>
                <i className="fa fa-angle-left" />
                <FormattedMessage id="summary.actions.back" tagName="span" />
              </button>
              <button className={`btn btn--small ${isBusinessGuide ? 'btn--outline' : ''}`} onClick={onPrintClick}>
                <i className="lni-printer" role="img" aria-label="Printer" />
                <FormattedMessage id="summary.actions.print" tagName="span" />
              </button>
            </div>
          </div>
          <div className="d-flex flex-row justify-content-center">
            <div className={`${pageCssBEM}__message p-2`}>
              <FormattedHTMLMessage id={`${pageCssBEM}.message`} tagName="p" />
            </div>
          </div>
          <div className={`d-flex justify-content-start ${pageCssBEM}__headerContact`}>
          </div>
        </div>
        <div className={`${pageCssBEM}__productsWrapper`}>
          <div className={`${pageCssBEM}__products ${isBusinessGuide ? '' : 'consumer'}`}>
            {(productList || []).map((product) => (
              <Product
                product={product}
                key={product.id}
                horizontalLayout={false}
                actionCompleted={actionCompleted}
                productFeaturesExpanded={true}
              />
            ))}
          </div>
          {!isBusinessGuide && (
            <div className={`${pageCssBEM}__otherProducts`}>
              <div className="product">
                <div className="product__header consumer">
                  <FormattedMessage id="otherAccounts" tagName="h1" />
                </div>
                <div className="list-action-wrapper">
                  <ul>{renderOtherAccounts()}</ul>
                </div>
              </div>
            </div>
          )}
        </div>
        <div className={`${pageCssBEM}__answersWrapper`}>
          <FormattedMessage id={`${pageCssBEM}.bankingStyle`} tagName="h1" />
          <div className={`${pageCssBEM}__answersWrapper--answers container`}>
            <AnswersList answers={answers} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default connect(
  (state, { location }) => {
    const { progress: { total = 0 } = {} } = state;

    const answers = state.answers || {};
    const products = state.products || {};
    const user = state.user || {};
    const detailsUrl = buildPageUrl({
      type: "details",
      uuid: user.uuid,
    });
    const summaryUrl = buildPageUrl({
      type: "summary",
      uuid: user.uuid,
    });
    return {
      user,
      answers,
      products,
      detailsUrl,
      summaryUrl,
    };
  },
  (dispatch) => {
    return {
      actionCompleted: (actionName) => {
        dispatch(actionCompleted({ actionName }));
      },
    };
  }
)(DetailsPage);
